import { Link } from "react-router-dom";

export default function MinimalFooter() {
  return (
    <footer className="border-t border-border/60 bg-background py-6">
      <div className="container flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs text-muted-foreground">
        <Link to="/impressum" className="hover:text-foreground transition-colors">Impressum</Link>
        <span aria-hidden>·</span>
        <Link to="/datenschutz" className="hover:text-foreground transition-colors">Datenschutz</Link>
        <span aria-hidden>·</span>
        <a href="mailto:info@torflash.de" className="hover:text-foreground transition-colors">Kontakt</a>
      </div>
    </footer>
  );
}
